module.exports = "<p>\n  payroll-sanction-grid works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component.html
// module id = ./src/app/hrms/payroll/payroll-sanction/payroll-sanction-grid/payroll-sanction-grid.component.html
// module chunks = main